<template>
    <!-- 加一点动画效果 -->
    <transition name="toast" @after-leave="onAfterLeave">
      <div class="toast" v-if="isShow">
        <div class="toast-content">
          <div class="content">{{ content }}</div>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    name: 'webToast',
    props: {
      // 显示时间，默认2s，传小于0的值不自动消失，需要手动关闭
      time: {
        type: Number,
        default: 1500,
      },
      // 弹窗文案文本对齐方式，默认center
      textAlign: {
        type: String,
        default: 'center',
      },
      // 类型,默认图标（√），传'warn'显示（！），传其他值则不显示icon，传'icon'不显示文本
      type: {
        type: String,
        default: 'success',
      },
      // 接收的函数方法
      hide: {
        type: Function,
        default: () => {},
      },
    },
    data() {
      return {
        content:'',
        isShow: false,
      };
    },
    methods: {
      show(msg) {
        this.content = msg;
        this.isShow = true;
        if (this.time >= 0) {
          setTimeout(() => {
            this.isShow = false;
          }, this.time);
        }
      },
      hidden() {
        this.isShow = false;
      },
      onAfterLeave() {
        this.hide();
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .toast-enter-active,
  .toast-leave-active {
    transition: opacity 0.3s ease-out;
  }
  .toast-enter-from,
  .toast-leave-to {
    opacity: 0;
  }
  .toast {
    position: fixed;
    top: 20%;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 99999999999999;
    background: rgba(0, 0, 0, 0.66);
    border-radius:.125rem /* 10/80 */;
    text-align: center;
    min-width:5.333333rem /* 200/37.5 */;
    padding: .266667rem /* 10/37.5 */ .213333rem /* 8/37.5 */;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #fff;
    .toast-content {
      display: flex;
    }
    .content {
      font-size: .373333rem /* 14/37.5 */;
      color: #fff;
    }
  }
  </style>